/**
 * assets/cart-drawer-recs.js
 *
 * 1. Handles "Add" button clicks for the cart-drawer-recommendations
 *    snippet, via event delegation on document (so it survives the
 *    drawer's HTML being replaced by AJAX / innerHTML swaps).
 * 2. Initializes (and re-initializes) the Swiper slider inside that
 *    snippet, since Swiper.init() must run again every time the
 *    drawer's markup is replaced.
 *
 * Load this ONCE, site-wide, via theme.liquid, right before </body>:
 *   {{ 'cart-drawer-recs.js' | asset_url | script_tag }}
 *
 * Do NOT put this script tag inside the snippet itself — injected
 * <script> tags never execute when set via innerHTML.
 */
(function () {
  var drawerRecsSwiper = null;
  var lastCartToken = null;

  function initCartDrawerRecsSlider() {
    var el = document.getElementById('drawer-slider-recs');
    if (!el || typeof Swiper === 'undefined') return;

    var currentToken = el.getAttribute('data-cart-token');

    // If the slider already exists and the cart hasn't actually changed
    // since we last built it, do nothing. Without this check, the
    // MutationObserver below (which has to watch the whole page, not
    // just the drawer) rebuilds Swiper on every unrelated page mutation
    // — review widgets, lazy-loaded images, chat widgets, etc. — which
    // resets the slide position mid-interaction and makes the arrows
    // look broken (they DO move the slide, just get reset a moment
    // later by the next incidental mutation elsewhere on the page).
    if (drawerRecsSwiper && currentToken === lastCartToken) {
      return;
    }

    if (drawerRecsSwiper) {
      drawerRecsSwiper.destroy(true, true);
      drawerRecsSwiper = null;
    }

    lastCartToken = currentToken;

    drawerRecsSwiper = new Swiper('#drawer-slider-recs', {
      slidesPerView: 2.2,
      spaceBetween: 12,
      navigation: {
        nextEl: '.arrow-next-drawer-recs',
        prevEl: '.arrow-prev-drawer-recs',
      },
      speed: 600,
    });
  }
  // Expose globally so it can be re-run after cart refresh below.
  window.initCartDrawerRecsSlider = initCartDrawerRecsSlider;

  document.addEventListener('DOMContentLoaded', initCartDrawerRecsSlider);

  // Watch for ANY change to the cart drawer — from your theme's own
  // "Add to cart" buttons on product/collection pages, its delete/remove
  // button, quantity +/- controls, or our own Add button — and re-init
  // the slider each time.
  //
  // We observe document.body (not #CartDrawer directly) because on a
  // fresh page load, the drawer element may not exist in the DOM yet —
  // many themes only create it the first time it's opened. Observing an
  // element that doesn't exist yet attaches to nothing, silently. That
  // was the specific bug: after adding a product via your theme's own
  // button, the drawer got created for the first time and our observer
  // (attached earlier to a null target) never saw it — only a full page
  // reload worked, because by then the drawer already existed at
  // DOMContentLoaded with the correct markup.
  //
  // Observing body + subtree is broader than ideal (it fires on
  // unrelated DOM changes elsewhere on the page too), but the 50ms
  // debounce keeps that cheap, and initCartDrawerRecsSlider() itself is
  // a no-op if #drawer-slider-recs isn't present.
  function watchCartDrawerForChanges() {
    var debounceTimer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(initCartDrawerRecsSlider, 50);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', watchCartDrawerForChanges);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-variant]');
    if (!btn || btn.disabled) return;

    var variantId = btn.dataset.addVariant;
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(refreshCartDrawer)
      .then(function () {
        btn.textContent = 'Added ✓';
        btn.classList.add('added');
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalText;
          btn.classList.remove('added');
        }, 1500);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });

  // Re-render the cart drawer's contents (line items, totals, and this
  // recommendations block) using Shopify's section-rendering API.
  // Swap 'cart-drawer' below for your section's actual filename/id if different,
  // and 'CartDrawer' for your drawer's actual element id.
  function refreshCartDrawer() {
    return fetch('/?sections=cart-drawer')
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        var newDrawerHtml = sections['cart-drawer'];
        var currentDrawer = document.getElementById('CartDrawer');
        if (!newDrawerHtml || !currentDrawer) return;

        var parsed = new DOMParser().parseFromString(newDrawerHtml, 'text/html');
        var newInner = parsed.getElementById('CartDrawer');
        if (newInner) {
          currentDrawer.innerHTML = newInner.innerHTML;
        }

        // Re-init the slider on the freshly injected markup.
        initCartDrawerRecsSlider();

        // Also update your cart bubble/count element here if you have one, e.g.:
        // var count = parsed.querySelector('.cart-count');
        // if (count) document.querySelector('.cart-count').textContent = count.textContent;
      });
  }
})();